/* Page B: mini break-even calculator, quote checklist counter, audience carried into links to page A. */
(function () {
  'use strict';
  var money = function (n) { return '$' + Math.round(n).toLocaleString('en-AU'); };

  /* mini break-even */
  var be = document.querySelector('[data-be]');
  if (be) {
    var rent = be.querySelector('#be-rent'), costs = be.querySelector('#be-costs'), price = be.querySelector('#be-price');
    var num = be.querySelector('[data-be-num]'), work = be.querySelector('[data-be-work]');
    var out = function (k) { return be.querySelector('[data-be-out="' + k + '"]'); };
    var calc = function () {
      var rentM = +rent.value * 52 / 12;
      var per = +price.value * 52 / 12;
      var members = Math.ceil((rentM + +costs.value) / per);
      out('rent').textContent = money(rent.value);
      out('costs').textContent = money(costs.value);
      out('price').textContent = money(price.value);
      num.textContent = members.toLocaleString('en-AU');
      work.textContent = '(' + money(rentM) + ' rent + ' + money(costs.value) + ' costs) ÷ ' + money(per) + ' per member each month.';
    };
    [rent, costs, price].forEach(function (i) { i.addEventListener('input', calc); });
    [rent, costs, price].forEach(function (i) { i.addEventListener('change', function () { if (window.verveTrack) window.verveTrack('story_calc', { members: num.textContent }); }); });
    calc();
  }

  /* quote checklist */
  var spec = document.querySelector('.spec');
  if (spec) {
    var count = spec.querySelector('[data-spec-count]');
    var boxes = spec.querySelectorAll('input[type=checkbox]');
    spec.addEventListener('change', function () {
      var n = Array.prototype.filter.call(boxes, function (b) { return b.checked; }).length;
      count.textContent = n + ' OF ' + boxes.length;
    });
  }

  /* carry the audience into links to page A */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-keep-aud]');
    if (!a) return;
    var aud = document.documentElement.dataset.for;
    if (!aud || aud === 'founder') return;
    try { var u = new URL(a.href, location.href); u.searchParams.set('for', aud); u.searchParams.set('from', 'story'); a.href = u.toString(); } catch (x) {}
  });
})();
